module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-elle-hughes-2696064-d8113a1d77286097dc98ef8ba3b9346e.jpg";